import React from "react";
import { Field, FieldArray, reduxForm } from "redux-form";
import { renderField, renderselect } from "../../../../Components/Forms/renders";
import HeaderFields from "./HeaderFields";

const ApiConfigForm = ({ handleSubmit, onCancel, pristine, submitting, invalid, initialValues }) => {
  // Check of we aan het editen zijn (bestaand record) of een nieuw record maken
  const isEditing = !!(initialValues && initialValues._id);
  const boekingssystemen = {
    tommy: "Tommy",
    boekingsexpert: "Boekingsexpert",
    recranet: "RecraNet",
    muws: "Muws",
    maxxton: "Maxxton"
  };

  const authOptions = {
    none: "Geen authenticatie",
    bearer: "Bearer Token",
    basic: "Basic Auth",
    api_key: "API Key",
    oauth: "OAuth 2.0"
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="modal-body">
        {/* Boekingssysteem selectie */}
        <div className="mb-3">
          <Field
            name="naam"
            component={renderselect}
            label="Boekingssysteem"
            options={boekingssystemen}
          />
        </div>

        {/* URL veld */}
        <div className="mb-3">
          <Field
            name="url"
            component={renderField}
            type="url"
            label="API URL"
            placeholder="https://api.example.com/endpoint"
          />
        </div>

        {/* Authenticatie methode */}
        <div className="mb-3">
          <Field
            name="authMethod"
            component={renderselect}
            label="Authenticatie methode"
            options={authOptions}
          />
        </div>

        {/* Authenticatie configuratie velden */}
        <Field name="authMethod" component={({ input }) => {
          const authMethod = input.value;
          
          return (
            <div className="mb-3">
              {authMethod === 'bearer' && (
                <Field
                  name="authConfig.token"
                  component={renderField}
                  type="password"
                  label="Bearer Token"
                  placeholder="Voer uw bearer token in"
                />
              )}
              
              {authMethod === 'basic' && (
                <div className="row">
                  <div className="col-md-6">
                    <Field
                      name="authConfig.username"
                      component={renderField}
                      type="text"
                      label="Gebruikersnaam"
                    />
                  </div>
                  <div className="col-md-6">
                    <Field
                      name="authConfig.password"
                      component={renderField}
                      type="password"
                      label="Wachtwoord"
                    />
                  </div>
                </div>
              )}
              
              {authMethod === 'api_key' && (
                <div className="row">
                  <div className="col-md-6">
                    <Field
                      name="authConfig.keyName"
                      component={renderField}
                      type="text"
                      label="API Key naam"
                      placeholder="bijv. X-API-Key"
                    />
                  </div>
                  <div className="col-md-6">
                    <Field
                      name="authConfig.keyValue"
                      component={renderField}
                      type="password"
                      label="API Key waarde"
                    />
                  </div>
                </div>
              )}
              
              {authMethod === 'oauth' && (
                <div className="alert alert-info">
                  <i className="fa fa-info-circle me-2"></i>
                  OAuth 2.0 configuratie wordt in een latere versie toegevoegd.
                </div>
              )}
            </div>
          );
        }} />

        {/* Headers sectie */}
        <div className="mb-3">
          <FieldArray name="headers" component={HeaderFields} />
        </div>
      </div>

      <div className="modal-footer">
        <button type="button" className="btn btn-secondary" onClick={onCancel}>
          Annuleren
        </button>
        <button type="submit" className="btn btn-primary" disabled={submitting || (!isEditing && pristine)}>
          {submitting ? 'Bezig met opslaan...' : 'Opslaan'}
        </button>
      </div>
    </form>
  );
};

export default reduxForm({
  form: "apiConfigForm"
})(ApiConfigForm);